import { Modal, Button } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { device } from 'utils/device'

const button = css`
  border: 0;
  margin-top: 1rem;
  margin-right: 1rem;
  > span {
    font-size: 0.8rem;
  }
`

export const ModalFooter = styled(Modal.Footer)`
  border: 0;
  justify-content: center;
`

export const ModalContainer = styled(Modal)`
  font-size: ${({ theme }) => theme.sizes.normal};
  color: ${({ theme }) => theme.palette.grayscale[1]};

  .modal-content {
    padding: 1rem 2rem;
    border: 0;
    box-shadow: 1px 1px 26px 8px rgba(0,0,0,0.47);
    -webkit-box-shadow: 1px 1px 26px 8px rgba(0,0,0,0.47);
    -moz-box-shadow: 1px 1px 26px 8px rgba(0,0,0,0.47);
  }

  input,
  textarea {
    font-size: 0.8rem;
  }

  .form-row > .col {
    margin-right: 2.5rem;
    @media ${device.mobileL} {
      margin-right: 0;
    }
  }
`

export const Header = styled(Modal.Header)`
  border: 0;
  > .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  a {
    color: ${({ theme }) => theme.palette.primary[2]};
  }
`

export const ModalTitle = styled.div`
  font-size: 1.2rem;
  text-align: center;
  color: #464747;
  font-weight: 200;
`

export const ModalSubtitle = styled.div`
  font-size: 1rem;
  font-weight: 300;
`

export const CancelButton = styled(Button)`
  background-color: ${(props) => props.theme.button.secondary};
  ${button}
`

export const OkButton = styled(Button)`
  background-color: ${(props) => props.theme.button.primary};
  ${button}
`
